"use strict";

var _classCallCheck = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RuleTranslator = void 0;

var base_1 = require("../common/base");

var pattern_1 = require("../common/pattern");

var RuleTranslator = /*#__PURE__*/function (_base_1$Translator) {
  _inherits(RuleTranslator, _base_1$Translator);

  function RuleTranslator() {
    var _this;

    _classCallCheck(this, RuleTranslator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RuleTranslator).call(this));
    _this.cache = {
      name: "__undefined__",
      chunkOutput: null,
      rule: null
    };
    return _this;
  }

  _createClass(RuleTranslator, [{
    key: "translate",
    value: function translate(chunkInput) {
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
      //
      var name = chunkInput.rule.name;
      var chunkOutput = Reflect.apply(chunkInput.rule, null, [chunkInput.props]);
      var pattern = pattern_1.translate(chunkOutput, actions); //

      this.cache.name = name;
      this.cache.chunkOutput = chunkOutput;
      this.cache.rule = chunkInput.rule; //

      var rule = "".concat(name, " \"").concat(name, "\" = ").concat(pattern);
      return rule;
    }
  }]);

  return RuleTranslator;
}(base_1.Translator);

exports.RuleTranslator = RuleTranslator;